import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { ChatConfigStore, ChatInfoStore, chatInitialState } from './definitions'

export const chatSlice = createSlice({
  name: 'chatSlice',
  initialState: chatInitialState,
  reducers: {
    setConfigurations: (
      state,
      { payload }: PayloadAction<ChatConfigStore>
    ) => ({
      ...state,
      config: payload,
    }),
    setInfo: (state, { payload }: PayloadAction<ChatInfoStore>) => ({
      ...state,

      info: payload,
    }),
    setVisible: (state, { payload }: PayloadAction<boolean>) => ({
      ...state,
      visible: payload,
    }),
    setHideInternal: (state, { payload }: PayloadAction<boolean>) => ({
      ...state,
      hideInternal: payload,
    }),
  },
})

export const { setConfigurations, setHideInternal, setInfo, setVisible } = chatSlice.actions
export default chatSlice.reducer
